import React from 'react'

const DEFAULT_TYPING_SPEED_MS = 5

export function useTypingEffect(
  text: string,
  {
    isAnimating = false,
    typingSpeed = DEFAULT_TYPING_SPEED_MS,
  }: { isAnimating?: boolean; typingSpeed?: number } = {},
) {
  const [displayedText, setDisplayedText] = React.useState('')
  const [isTyping, setIsTyping] = React.useState(false)

  React.useEffect(() => {
    if (!text.startsWith(displayedText)) {
      setDisplayedText('')
    }
  }, [text, displayedText])

  React.useEffect(() => {
    if (isAnimating && displayedText.length < text.length) {
      setIsTyping(true)
      const minChunk = 1
      const maxChunk = 5
      const chunkSize = Math.floor(Math.random() * (maxChunk - minChunk + 1)) + minChunk
      const nextLength = Math.min(displayedText.length + chunkSize, text.length)
      const timeout = setTimeout(() => {
        setDisplayedText(text.slice(0, nextLength))
      }, typingSpeed)
      return () => clearTimeout(timeout)
    } else {
      if (displayedText !== text) {
        setDisplayedText(text)
      }
      setIsTyping(false)
    }
  }, [isAnimating, displayedText, text, typingSpeed])

  return { displayedText, isTyping }
}
